export default __webpack_public_path__ + "static/media/LIMBO.b240a26f.jpg";